import XLSX from 'xlsx'
import { schema } from './schemas/balancete'
const NOME_TABELA = 'Balancete Mensal'

const iniciar = (file, callback) => {
  const reader = new FileReader()
  reader.onload = async function (e) {
    var data = new Uint8Array(e.target.result)
    var workbook = await XLSX.read(data, { type: 'array' })
    await construirObjetoBalancete(workbook, (balancete) => {
      callback(balancete)
    })
  }
  return reader.readAsArrayBuffer(file)
}

export default iniciar

const construirObjetoBalancete = async (workbook, callback) => {
  const index = workbook.SheetNames.indexOf(NOME_TABELA)
  if (index > -1) {
    const worksheet = workbook.Sheets[NOME_TABELA]
    let balancete = await balanceteToObject(worksheet)
    callback(balancete)
  } else {
    alert('Não existe uma tabela com o nome X neste arquivo.')
  }
}

const validaObjetoBalancete = async (balancete) => {
  const teste = await schema.validateAsync(balancete, { abortEarly: false }).catch(error => {
    console.log(error)
    return alert('Erro ao validar os dados do balancete.')
  })
  return teste
}

const balanceteToObject = async worksheet => {
  let objeto = {}

  let tabela = await XLSX.utils.sheet_to_json(worksheet, {
    raw: false,
    header: 'A'
  })

  objeto.vacas_total_lactacao = parseInt(
    tabela[6].C.replace(/ vacas/i, '') // vacas_total_lactacao
  )
  objeto.vacas_inicio_lactacao = parseInt(
    tabela[7].B.replace(/ Vacas em Início de Lactação/i, '') // vacas_inicio_lactacao
  )
  objeto.vacas_meio_lactacao = parseInt(
    tabela[8].B.replace(/ Vacas em Meio de Lactação/i, '') // vacas_meio_lactacao
  )
  objeto.vacas_fim_lactacao = parseInt(
    tabela[9].B.replace(/ Vacas em Final de Lactação/i, '') // vacas_fim_lactacao
  )
  // Receita com Leite
  objeto.producao_media_leite = parseFloat(
    tabela[11].C.replace(' L/vaca/dia', '') // producao_media_leite
  )
  objeto.producao_estimada_dia = parseInt(
    tabela[12].C.replace(/ litros/i, '') // producao_estimada_dia
  )
  tabela[13].C = tabela[13].C.replace(/ litros/i, '')
  objeto.producao_estimada_mes = parseInt(
    tabela[13].C.replace(/,/g, '') // producao_estimada_mes
  )
  objeto.consumo_mensal_familia_estimado = parseInt(
    tabela[14].C.replace(/ litros/g, '') // consumo_mensal_familia_estimado
  )
  objeto.consumo_mensal_bezerras_estimado = parseInt(
    tabela[15].C.replace(/ litros/g, '') // consumo_mensal_bezerras_estimado
  )
  tabela[16].C = tabela[16].C.replace(/ litros/i, '')
  objeto.quantidade_disponivel_venda = parseInt(
    tabela[16].C.replace(/,/g, '') // quantidade_disponivel_venda
  )
  objeto.valor_pago_leite = parseFloat(
    tabela[17].C.replace('R$ ', '') // valor_pago_leite
  )
  objeto.receita_bruta_dia = parseFloat(
    tabela[18].C.replace('R$ ', '') // receita_bruta_dia
  )
  tabela[19].C = tabela[19].C.replace('R$ ', '')
  objeto.receita_bruta_mes = parseFloat(
    tabela[19].C.replace(/,/g, '') // receita_bruta_mes
  )
  tabela[20].C = tabela[20].C.replace('R$ ', '')
  objeto.receita_bruta_mes_leite = parseFloat(
    tabela[20].C.replace(/,/g, '') // receita_bruta_mes_leite
  )
  // Alimentação das Vacas em Lactação
  tabela[22].C = tabela[22].C.replace('R$ ', '')
  objeto.lactacao_custo_alimentacao_concentrada = parseFloat(
    tabela[22].C.replace(/,/g, '') // lactacao_custo_alimentacao_concentrada
  )
  tabela[23].C = tabela[23].C.replace('R$ ', '')
  objeto.lactacao_custo_alimentacao_volumosa = parseFloat(
    tabela[23].C.replace(/,/g, '') // lactacao_custo_alimentacao_volumosa
  )
  tabela[24].C = tabela[24].C.replace('R$ ', '')
  objeto.lactacao_total_alimentacao = parseFloat(
    tabela[24].C.replace(/,/g, '') // lactacao_total_alimentacao
  )
  // Alimentação das Vacas Secas e no Pré Parto
  tabela[26].C = tabela[26].C.replace('R$ ', '')
  objeto.pre_parto_custo_alimentacao_concentrada = parseFloat(
    tabela[26].C.replace(/,/g, '') // pre_parto_custo_alimentacao_concentrada
  )
  tabela[27].C = tabela[27].C.replace('R$ ', '')
  objeto.pre_parto_custo_alimentacao_volumosa = parseFloat(
    tabela[27].C.replace(/,/g, '') // pre_parto_custo_alimentacao_volumosa
  )
  tabela[28].C = tabela[28].C.replace('R$ ', '')
  objeto.pre_parto_total_alimentacao = parseFloat(
    tabela[28].C.replace(/,/g, '') // pre_parto_total_alimentacao
  )
  // Alimentação das Bezerras e Novilhas
  tabela[30].C = tabela[30].C.replace('R$ ', '')
  objeto.bezerras_custo_leite = parseFloat(
    tabela[30].C.replace(/,/g, '') // bezerras_custo_leite
  )
  tabela[31].C = tabela[31].C.replace('R$ ', '')
  objeto.bezerras_custo_alimentacao_concentrada = parseFloat(
    tabela[31].C.replace(/,/g, '') // bezerras_custo_alimentacao_concentrada
  )
  tabela[32].C = tabela[32].C.replace('R$ ', '')
  objeto.bezerras_custo_alimentacao_volumosa = parseFloat(
    tabela[32].C.replace(/,/g, '') // bezerras_custo_alimentacao_volumosa
  )
  tabela[33].C = tabela[33].C.replace('R$ ', '')
  objeto.bezerras_total_alimentacao = parseFloat(
    tabela[33].C.replace(/,/g, '') // bezerras_total_alimentacao
  )
  // Alimentação do Rebanho
  tabela[35].C = tabela[35].C.replace('R$ ', '')
  objeto.rebanho_custo_leite = parseFloat(
    tabela[35].C.replace(/,/g, '') // rebanho_custo_leite
  )
  tabela[36].C = tabela[36].C.replace('R$ ', '')
  objeto.rebanho_custo_alimentacao_concentrada = parseFloat(
    tabela[36].C.replace(/,/g, '') // rebanho_custo_alimentacao_concentrada
  )
  tabela[37].C = tabela[37].C.replace('R$ ', '')
  objeto.rebanho_custo_alimentacao_volumosa = parseFloat(
    tabela[37].C.replace(/,/g, '') // rebanho_custo_alimentacao_volumosa
  )
  tabela[38].C = tabela[38].C.replace('R$ ', '')
  objeto.rebanho_custo_alimentacao = parseFloat(
    tabela[38].C.replace(/,/g, '') // rebanho_custo_alimentacao
  )
  // Custo da suplementação mineral
  tabela[40].C = tabela[40].C.replace('R$ ', '')
  objeto.vacas_lactacao_custo_mineral = parseFloat(
    tabela[40].C.replace(/,/g, '') // vacas_lactacao_custo_mineral
  )
  tabela[41].C = tabela[41].C.replace('R$ ', '')
  objeto.pre_parto_custo_mineral = parseFloat(
    tabela[41].C.replace(/,/g, '') // pre_parto_custo_mineral
  )
  tabela[42].C = tabela[42].C.replace('R$ ', '')
  objeto.bezerras_custo_mineral = parseFloat(
    tabela[42].C.replace(/,/g, '') // bezerras_custo_mineral
  )
  tabela[43].C = tabela[43].C.replace('R$ ', '')
  objeto.total_custo_mineral = parseFloat(
    tabela[43].C.replace(/,/g, '') // total_custo_mineral
  )
  // Sobras (com relação à alimentação)
  tabela[45].C = tabela[45].C.replace('R$ ', '')
  objeto.sobra_receita_estimada = parseFloat(
    tabela[45].C.replace(/,/g, '') // sobra_receita_estimada
  )
  tabela[46].C = tabela[46].C.replace('R$ ', '')
  objeto.sobra_despesa_estimada = parseFloat(
    tabela[46].C.replace(/,/g, '') // sobra_despesa_estimada
  )
  tabela[47].C = tabela[47].C.replace('R$ ', '')
  objeto.sobra_total_estimada = parseFloat(
    tabela[47].C.replace(/,/g, '') // sobra_total_estimada
  )
  // Qualidade
  objeto.qualidade_rtm_pb = parseFloat(
    tabela[12].E.replace(/,/g, '') // qualidade_rtm_pb
  )
  objeto.qualidade_rtm_ndt = parseFloat(
    tabela[12].F.replace(/,/g, '') // qualidade_rtm_ndt
  )
  // Custos
  tabela[15].E = tabela[15].E.replace('Concentrado: R$ ', '')
  tabela[15].E = tabela[15].E.replace('/Kg', '')
  objeto.custo_racao_concentrada = parseFloat(
    tabela[15].E.replace(/,/g, '') // custo_racao_concentrada
  )
  tabela[16].E = tabela[16].E.replace('Volumoso: R$ ', '')
  tabela[16].E = tabela[16].E.replace('/Kg', '')
  objeto.custo_racao_volumosa = parseFloat(
    tabela[16].E.replace(/,/g, '') // custo_racao_volumosa
  )
  tabela[17].E = tabela[17].E.replace('Ração Total: R$ ', '')
  tabela[17].E = tabela[17].E.replace('/Kg', '')
  objeto.custo_racao_total = parseFloat(
    tabela[17].E.replace(/,/g, '') // custo_racao_total
  )
  tabela[20].E = tabela[20].E.replace('Custo: R$ ', '')
  tabela[20].E = tabela[20].E.replace('/Litro', '')
  objeto.custo_alimentacao_litro = parseFloat(
    tabela[20].E.replace(/,/g, '') // custo_alimentacao_litro
  )

  console.log(objeto)

  return validaObjetoBalancete(objeto)
}
